var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_14137_9878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 2H7.5C6.66875 2 6 2.66875 6 3.5V13.9062L4.84375 12.95C4.58125 12.7375 4.3 12.5563 4 12.4125V3.5C4 1.56875 5.56875 0 7.5 0H24.5C26.4312 0 28 1.56875 28 3.5V12.4125C27.7 12.5563 27.4188 12.7375 27.1625 12.95L26 13.9062V3.5C26 2.66875 25.3312 2 24.5 2ZM2.1875 16C2.0875 16 2 16.0812 2 16.1875V28C2 29.1063 2.89375 30 4 30H28C29.1063 30 30 29.1063 30 28V16.1875C30 16.0875 29.9188 16 29.8125 16C29.7687 16 29.7313 16.0125 29.6938 16.0438L18.4062 25.3188C17.7313 25.875 16.875 26.1812 16 26.1812C15.125 26.1812 14.2688 25.875 13.5938 25.3188L2.3 16.0438C2.26875 16.0188 2.225 16 2.18125 16H2.1875ZM0 16.1875C0 14.9812 0.975 14 2.1875 14C2.69375 14 3.18125 14.175 3.575 14.4937L14.8625 23.7687C15.1813 24.0312 15.5875 24.175 16 24.175C16.4125 24.175 16.8188 24.0312 17.1375 23.7687L28.4312 14.4937C28.825 14.175 29.3125 14 29.8188 14C31.025 14 32.0062 14.975 32.0062 16.1875V28C32.0062 30.2062 30.2125 32 28.0063 32H4C1.79375 32 0 30.2062 0 28V16.1875ZM11 8H21C21.55 8 22 8.45 22 9C22 9.55 21.55 10 21 10H11C10.45 10 10 9.55 10 9C10 8.45 10.45 8 11 8ZM11 14H21C21.55 14 22 14.45 22 15C22 15.55 21.55 16 21 16H11C10.45 16 10 15.55 10 15C10 14.45 10.45 14 11 14Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14137_9878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/Step_5.393a65b35282eda8bb315f107ff8aea8.svg";
export { ForwardRef as ReactComponent };